import { ecoFarm } from 'config/constants/ecoBoost'
import { useFarms } from 'state/farms/hooks'
import { isEcoFarmSupported } from 'utils/isNftStakingSupported'
import { getRewarderV2AddressByPid, useViewEcoBoostFactor } from 'hooks/rewarderV2/useRewarderV2Contract'
import { DEFAULT_REWARDER_V2_DECIMAL } from 'config'

export const useGetEcoBoostFactor = (farmId: number) => {
  const isEcoFarm = isEcoFarmSupported(farmId)
  const { data: farmsLP } = useFarms()
  const targetFarmDetails = farmsLP.find((farm) => farm.pid === farmId)
  const ecoConfig = ecoFarm[targetFarmDetails?.ecoFarm]

  const { data: viewActualEcoBoostFactor, isLoading } = useViewEcoBoostFactor(
    getRewarderV2AddressByPid(farmId),
    farmId,
    {
      enabled: isEcoFarm && !!ecoConfig,
    },
  )

  const actualBoostFactor =
    isEcoFarm && !!ecoConfig && !isLoading && viewActualEcoBoostFactor
      ? parseFloat(viewActualEcoBoostFactor?.toString() ?? DEFAULT_REWARDER_V2_DECIMAL.toString()) /
        DEFAULT_REWARDER_V2_DECIMAL
      : 1
  return { data: actualBoostFactor, isEcoBoosted: actualBoostFactor > 1, isLoading }
}

export default useGetEcoBoostFactor
